import { Anchor, AppShell, Box, Flex, Image, Text, Title } from "@mantine/core";
import HomePage from "./pages/homepage";
import { FaHeart } from "react-icons/fa";
import NewHomepage from "./pages/newhomepage";
import stache from "./assets/stache.png";
import "./themes/fonts.css";

function App() {
  return (
    <AppShell
      header={{height: 60}}
      padding="md"
    >
      {/* <AppShell.Header
      >
        <Flex
          justify="space-between"
          align="center"
          style={{ height: "100%" }}
          pl="1rem"
          pr="1rem"
        >
          <Box>
              <Image src={stache} alt="Logo"  height={30}  />
          </Box>
          <Flex>
            <Anchor c="white" underline="hover" fw="bold" href="https://license.stacher.io/?donate" target="_blank">Support Stacher</Anchor>
          </Flex>
        </Flex>
      </AppShell.Header> */}
      <AppShell.Main
        p={"0"}
      >
        {/* <HomePage /> */}
        <NewHomepage />
      </AppShell.Main>
    </AppShell>
  );
}

export default App;
